module.exports = __webpack_public_path__ + "img/ended-contracts.7b251e23.svg";